<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="510px"></v-dialog>

 

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formmasterpaket" v-model="validmasterpaket" lazy-validation>
                      <v-layout wrap>

                        <v-flex xs12 sm12 md12>
                          <div v-show="codegorunum === true ">
                            <v-text-field label="Tur Kodu" :color="color" v-model="MasterTur.TurKodu" > </v-text-field>
                             
                              
                           
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Tur Adı" :color="color" v-model="MasterTur.TurAdi"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            label="Kategori"
                            v-model="MasterTur.KategoriId"
                            item-text="KategoriAdi"
                            item-value="Id"
                            items="kategoriler"
                            
                          ></v-select></v-flex>
                          <v-flex xs12 sm12 md12>
                          <v-select
                            label="Ürün Grubu"
                            v-model="MasterTur.UrunGrubuId"
                            item-text="UrunGrubuAdi"
                            item-value="Id"
                            items="urunGruplari"
                            
                          ></v-select></v-flex>
                          <v-flex xs12 sm12 md4>
                            <v-text-field label="Gündüz" :color="color" v-model="MasterTur.Gunduz"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field label="Gece" :color="color" v-model="MasterTur.Gece"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Notlar" :color="color" v-model="MasterTur.Notlar">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <div v-show="codegorunum === true ">
                            <v-text-field label="Kontenjan" :color="color" v-model="MasterTur.Kontenjan" > </v-text-field>
                             
                              
                           
                          </div>
                        </v-flex>

                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>

            <div v-show="m === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletemastertur()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>
            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>


            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{'Tur Ara'}}</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
    </v-layout>
    <v-container fluid>
  <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                   
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  
                  >
                  </tarihcomp>
                </v-flex>
                <v-flex xs12 sm2 md2>
                                    <v-select hide-details=""  label="Tur Kategori" item-text="text"  item-value="value">
                                    </v-select>
                                </v-flex>
                                <v-flex xs12 sm2 md2>
                                    <v-select hide-details=""  label="Ürün Grubu" item-text="text"  item-value="value">
                                    </v-select>
                                </v-flex>
               
                <v-flex>
                  <v-layout>
                    <v-btn color="info" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>

                    <v-btn small=""  color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
</v-container>

<v-layout row="" wrap >

  <v-flex pa-2   xs12 sm12 md12>
                    <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                            <v-list two-line="">
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>
                                                      

                                                        <v-flex sm12 md2 justify-start>
                                                          <v-img src="https://picsum.photos/350/165?random" height="120px" width="100%" contain>
                                                          </v-img>
                                                        </v-flex>
                                                        <v-flex sm12 md3 class="my-auto text-xs-center">
                                                          <span class="title" color="blue">Büyük İskandinavya Turu</span>
                                                          </br> Kısa Açıklama </br> Havayolu
                                                        </v-flex>
                                                        <v-flex sm12 md3 class="my-auto text-xs-center">
                                                         Başlangıç: 12.09.2024 </br>Bitiş: 22.09.2024 </br> 10 Gece - 11 Gün
                                                        </v-flex>
                                                        <v-flex sm12 md2 class="my-auto text-xs-center">
                                                         Başlangıç Fiyat: </br><span bold> 250 EUR </span>  </br>  <v-divider></v-divider> </br><v-btn flat>12 Alt Tur</v-btn> 
                                                        </v-flex>
                          
                                                        <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                                                          <router-link
                :to="{ name: 'turdetay' }"
              >
                                                          <v-btn
                   
                    color="success"
                  
                    >İncele
                    <v-icon right dark>search</v-icon>
                    </v-btn>
                  </router-link>
                   
             
              
               
                </v-flex>
                                                         

                                                      

                                                      

                                                     

                                                      

                                                      

                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>
                                </v-layout>

                            </v-list>
                        </v-card>
                    </v-hover>
                </v-flex>


</v-layout>

<v-layout row="" wrap >

<v-flex pa-2   xs12 sm12 md12>
                  <v-hover>
                      <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                          <v-list two-line="">
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                      <v-card flat class="black--text">
                                          <v-card flat="">
                                              <v-card-actions>
                                                  <v-layout row wrap>
                                                    

                                                      <v-flex sm12 md2 justify-start>
                                                        <v-img src="https://picsum.photos/350/165?577" height="120px" width="100%" contain>
                                                        </v-img>
                                                      </v-flex>
                                                      <v-flex sm12 md3 class="my-auto text-xs-center">
                                                        <span class="title" color="blue"> İtalya Turu</span>
                                                        </br> Kısa Açıklama </br> Havayolu
                                                      </v-flex>
                                                      <v-flex sm12 md3 class="my-auto text-xs-center">
                                                       Başlangıç: 12.09.2024 </br>Bitiş: 22.09.2024 </br> 10 Gece - 11 Gün
                                                      </v-flex>
                                                      <v-flex sm12 md2 class="my-auto text-xs-center">
                                                       Başlangıç Fiyat: </br><span bold> 250 EUR </span>  </br>  <v-divider></v-divider> </br><v-btn flat>12 Alt Tur</v-btn> 
                                                      </v-flex>
                        
                                                      <v-flex xs12 sm2 md2 class="my-auto text-xs-center">
                                                        <router-link
              :to="{ name: 'turdetay' }"
            >
                                                        <v-btn
                 
                  color="success"
                
                  >İncele
                  <v-icon right dark>search</v-icon>
                  </v-btn>
                </router-link>
                 
           
            
             
              </v-flex>
                                                       

                                                    

                                                    

                                                   

                                                    

                                                    

                                                  </v-layout>
                                              </v-card-actions>
                                          </v-card>
                                      </v-card>
                                  </v-flex>
                              </v-layout>

                          </v-list>
                      </v-card>
                  </v-hover>
              </v-flex>


</v-layout>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import tarihcomp from "../customcomp/tarihim";
  export default {
    data() {
      return {
        validbanka: true,
        passwordRules: [
          v => !!v || this.$t('This-space-cannot-left-blank'),
          v => (v && v.length < 5) || this.$t('Maximum-4-characters')
        ],
        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'Tur Kodu',
            value: 'TurKodu'
          },
          {
            text: 'Tur Adı',
            value: 'TurAdi'
          },
          {
            text: 'Ürün Grubu',
            value: 'UrunGurubuAdi'
          },
          {
            text: 'Kategori',
            value: 'KategoriAdi'
          },
          {
            text: 'Gündüz',
            value: 'Gunduz'
          },
          {
            text: 'Gece',
            value: 'Gee'
          },
          {
            text: 'Notlar',
            value: 'Notlar'
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        MasterTur: {
          Id: 3,
      TurKodu: "ABC",
      TurAdi: "ABC Tur",
      Notlar: "",
      Gece: 1,
      Gunduz: 1,
      Aktif: false,
      Kategori: {
        id: "0",
        kod: null,
        isim: null,
        tip: 0,
        intField: null,
      },
      UrunGrubu: {
        id: "0",
        kod: null,
        isim: null,
        tip: 0,
        intField: null,
      },
      Kontenjan: 0,
      KayitTarihi: "2024-09-11T16:22:28"


        },
        cari: '',
        state: [],
        dialogfiltre:false,
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => this.$t('Must-least-4-digits'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      


    
    },
    methods: {
      yeniekle() {
            var url = '#/pakettur/masterpaketislem/'

            window.open(url, '_self')
        },
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = this.$t('Update')

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

       
       
      },
      deletemastertur: deletemastertur,
      masterturekle: masterturekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      tarihcomp
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    
  }


  function Kaydet() {


    if (this.$refs.formbanka.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

     
  }
  }
  function masterturekle() {

    this.dialog = true
    this.MasterTur = {}
    this.dialog_baslik = 'Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletemastertur() {
    if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    
    }
  }

  function guncelle() {
   
  }
</script>

<style>

</style>